import styled from 'styled-components';

export const StyledNodeWrapper = styled.div<{
  selected: boolean;
  type?: 'sensor' | 'action';
  disabled?: boolean;
}>`
  display: flex;
  position: relative;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: fit-content;
  cursor: ${(props) => (props.disabled ? 'no-drop' : 'grab')};
  transition: all 0.2s ease;

  background-color: ${(props) =>
    // eslint-disable-next-line no-nested-ternary
    props.disabled
      ? '#8D8D8D'
      : props.type === 'action'
        ? '#ff008e'
        : '#239ae7'};

  box-shadow: ${(props) =>
    !props.disabled &&
    // eslint-disable-next-line no-nested-ternary
    (props.selected
      ? props.type === 'action'
        ? '0 0 0 1px #fff, 0 0 0 3px #FF008E'
        : '0 0 0 1px #fff, 0 0 0 3px #239ae7'
      : 'none')};

  &:hover {
    transform: ${(props) => (props.disabled ? 'none' : 'scale(1.035)')};
  }
`;

export const StyledErrorWrapper = styled.div`
  position: absolute;
  top: -90%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  white-space: nowrap;
`;
